import { useEffect, useState } from "react"
import { apiClient } from "@/lib/api"

interface Stats {
  users: { total: number; active: number; platform_admins: number }
  properties: { total: number; active: number }
  sessions: { active: number }
  recent_activity: Array<{ action: string; count: number }>
}

export function PlatformOverviewPage() {
  const [stats, setStats] = useState<Stats | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    apiClient.getPlatformStats().then((res) => {
      if (res.ok && res.stats) setStats(res.stats)
      setLoading(false)
    })
  }, [])

  if (loading) {
    return (
      <div style={{ padding: "var(--sf-space-8)", textAlign: "center" }}>
        <div className="sf-spinner" />
      </div>
    )
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-header__title">Platform Overview</h1>
        <p className="page-header__subtitle">System-wide metrics and activity</p>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "var(--sf-space-4)" }}>
        <StatCard label="Total Users" value={stats?.users.total ?? 0} />
        <StatCard label="Active Users" value={stats?.users.active ?? 0} />
        <StatCard label="Platform Admins" value={stats?.users.platform_admins ?? 0} />
        <StatCard label="Total Properties" value={stats?.properties.total ?? 0} />
        <StatCard label="Active Properties" value={stats?.properties.active ?? 0} />
        <StatCard label="Active Sessions" value={stats?.sessions.active ?? 0} />
      </div>

      <div className="section-card" style={{ marginTop: "var(--sf-space-6)" }}>
        <h2 style={{ fontSize: "var(--sf-text-md)", fontWeight: 600, marginBottom: "var(--sf-space-4)" }}>
          Recent Activity (24h)
        </h2>
        {stats?.recent_activity && stats.recent_activity.length > 0 ? (
          <table className="data-table">
            <thead>
              <tr>
                <th>Action</th>
                <th style={{ textAlign: "right" }}>Count</th>
              </tr>
            </thead>
            <tbody>
              {stats.recent_activity.map((item) => (
                <tr key={item.action}>
                  <td><code style={{ fontSize: "var(--sf-text-sm)" }}>{item.action}</code></td>
                  <td style={{ textAlign: "right" }}>{item.count}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="empty-state">
            <div className="empty-state__title">No recent activity</div>
          </div>
        )}
      </div>
    </div>
  )
}

function StatCard({ label, value }: { label: string; value: number }) {
  return (
    <div className="section-card">
      <div style={{ fontSize: "var(--sf-text-sm)", color: "var(--sf-text-muted)" }}>{label}</div>
      <div style={{ fontSize: "1.75rem", fontWeight: 600, marginTop: "var(--sf-space-2)" }}>
        {value.toLocaleString()}
      </div>
    </div>
  )
}
